import { Component, ComponentRef } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { atLeastOneRequiredValidator } from '../../shared/utils/atLeastOneRequiredValidator';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../domain/model/enums/notificationType';
import { NotificationComponent } from '../../shared/notification/notification.component';
import { ExternalUserChangePassword } from '../../domain/model/account/externalUserChangePassword';
import { passwordMatchValidator } from '../../shared/utils/mustMatchValidators';
import { AccountService } from '../../domain/service/accountService';

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrl: './set-password.component.css'
})
export class SetPasswordComponent {
  private overlayRef!: OverlayRef;

  constructor(private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly accountService: AccountService,private overlay: Overlay,private readonly route: ActivatedRoute) {
}
  hide = true;
  hideC = true;
  strongPassword = false;
  email: string = '';
  working = false;
  signupForm = new FormGroup({
    password: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
    ]),
    confirmPassword: new FormControl(null, [
      Validators.minLength(8),
      Validators.required,
      
    ]),
  } ,{validators: passwordMatchValidator('password', 'confirmPassword')});
  get f() {
    return this.signupForm.controls;
  }

  get passwordMismatch() {
    let confirmPassword =  this.signupForm.get('confirmPassword')?.value ?? '';
    return this.signupForm.hasError('passwordMismatch') && (confirmPassword.length > 0);
  }
  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.email = params.get('email')??'';
      // use id as needed
    });
    // Initialize an overlay and define a relative position
    // Change this to control where your toaster should appear
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .top("20px")
        .right("30px"),
    });
  }
  showNotification(message: string, title : string): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> =
      this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = NotificationType.Success;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();
    
    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 3000);
  }
  onPasswordStrengthChanged(event: boolean) {
    this.strongPassword = event;
  }
 
  onPasswordChange(){
    let changePasswowrd : ExternalUserChangePassword = {
      email: this.email,
      password: this.signupForm.get('password')?.value ??''
    }
    try {

      this.accountService.changePassword(changePasswowrd);
      this.showNotification('Password reset successfully', 'Password reset');
      this.router.navigate(['/login']); 
    
    } catch(e) {
      console.log(e); 
    }
  

  }

  backToLogin(){
    this.router.navigate(['/codeVerification' , this.email]); 
  }
}
